"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M20.207 4.311a.892.892 0 0 0-.194-.281.892.892 0 0 0-.288-.2l-.01-.004-.011-.004a.983.983 0 0 0-.162-.034.662.662 0 0 0-.138-.027h-.007l-4.947.04a.905.905 0 0 0-.037 1.81l2.794-.087-4.435 4.435a.892.892 0 1 0 1.262 1.262l4.446-4.446-.06 2.805a.905.905 0 0 0 .585.812.901.901 0 0 0 1.215-.874l.057-4.871a.54.54 0 0 0-.032-.176l-.03-.141-.008-.019ZM3.793 19.688a.893.893 0 0 0 .194.282c.081.085.18.153.287.2l.011.004.011.003a.97.97 0 0 0 .162.035.66.66 0 0 0 .138.027h.007l4.947-.04a.905.905 0 0 0 .037-1.81l-2.794.087 4.435-4.435a.892.892 0 0 0-1.262-1.262L5.52 17.224l.06-2.804a.903.903 0 0 0-.932-.869.9.9 0 0 0-.868.93l-.057 4.872c0 .06.012.12.032.176l.03.141.008.018Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};